import * as React from 'react';

import { IconProps } from './Icon';

export const TriangleIcon = ({
  width = 8,
  height = 6,
  className,
  color = 'none',
}: IconProps) => (
  <svg
    fill={color}
    height={height}
    viewBox="0 0 8 6"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.18912 4.8764C3.58825 5.42946 4.41175 5.42946 4.81088 4.87641L7.1861 1.58521C7.6634 0.923842 7.19083 0 6.37522 0H1.62478C0.809174 0 0.336598 0.923841 0.813896 1.58521L3.18912 4.8764Z"
      fill="#D9D9D9"
    />
  </svg>
);
